import React, {useState} from "react";

function LazyImage({src,type}) {

    const [load,setLoad] = useState(true)

    const getType= () =>{
        let urlType = "/other/skeleton/banner.jpg"
        switch (type) {
            case 'banner' :
                urlType = "/other/skeleton/banner.jpg";
                break;
            case 'side' :
                urlType = "/other/skeleton/side.jpg";
                break;
            case 'product' :
                urlType = "/other/skeleton/product.jpg";
                break;
        }

        return urlType;
    }

    return(
        <>
            <img onLoad={()=>setLoad(false)} src={src} alt=""/>
            {load?
                <>
                    <img src={getType()} alt=""/>
                </>
                :null}
        </>
    )
}

export {LazyImage};